import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import FaqBoardMobile from '@/components/help/mobile/common/FaqBoard';
import FaqBoardPc from '@/components/help/pc/common/FaqBoard';
import {UseGetFaqListInfinityResult, UseGetFaqListResult} from '@/hooks/help';

type FaqBoardProps = {
  type: 'faq' | 'search';
};

export type FaqBoardPcProps = FaqBoardProps &
  UseGetFaqListResult & {
    onPageChange: (page: number) => void;
  };

export type FaqBoardMobileProps = FaqBoardProps & UseGetFaqListInfinityResult;

const FaqBoard = (props: FaqBoardPcProps | FaqBoardMobileProps) => {
  const {isMobile} = useHelpContext();

  return isMobile ? (
    <FaqBoardMobile {...(props as FaqBoardMobileProps)} />
  ) : (
    <FaqBoardPc {...(props as FaqBoardPcProps)} />
  );
};

export default FaqBoard;
